import React, { useState, useEffect } from 'react';
import { selectLogin } from '../../../../store/login/loginSlice';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import {
  Stack,
  Typography,
  Button,
  Card,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Box,
  Menu,
  Fade,
  FormControl,
  FormControlLabel,
  Radio,
  Checkbox
} from '@mui/material';
import { isMobile } from 'react-device-detect';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';

import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/***
 * tables tb_profiles & tb_type_users
 * profiles 1 = admin, 2 = usuario, 3 = vendedor
 * typeusers 1 = operadora 2 = corretora
 */

const RepSales = (props) => {
  const [infosReport, setInfosReport] = useState([]);
  const [infosBrokers, setInfosBroker] = useState([]);
  const [infosSelectVend, setInfosSelectVend] = useState([]);
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  const [checkedControlYears, setCheckedControlYears] = useState(false);
  const [infosTypesOfHiring, setInfosTypesOfHiring] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (infoState.id_type_user === 1) {
      getBrokers();
    }
    if (infoState.id_type_user === 2 && infoState.id_profile !== 3) {
      setInfosReport({
        brokerSelected: infoState.name_broker,
        id_broker: infoState.id_broker
      });
      getInfoSelectVend();
    }
    if (infoState.id_type_user === 2 && infoState.id_profile === 3) {
      setInfosReport({
        ...infosReport,
        id_broker: infoState.id_broker,
        id_vend: infoState.id,
        brokerSelected: infoState.name_broker,
        infosSelectVend: `${infoState.id} - ${infoState.nome}`
      });
    }
    getTypesOfHiring();
  }, []);

  function getBrokers() {
    configAxios
      .post('/brokers/listBrokerLabelUsers')
      .then((response) => {
        setInfosBroker(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os corretores, tente novamente!',
          'Atenção'
        );
      });
  }

  function getInfoSelectVend(id_broker) {
    let idGetVend = id_broker ? id_broker : infoState.id_broker;
    configAxios
      .get(`/brokers/listVendLabel/${idGetVend}`)
      .then((response) => {
        setInfosSelectVend(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar a lista de vendedores! Tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event, broker, vend) {
    if (broker) {
      infosReport.infosSelectVend = '';
      if (event) {
        setInfosReport({
          ...infosReport,
          brokerSelected: event.label,
          id_broker: event.id,
          id_vend: null
        });
        getInfoSelectVend(event.id);
      } else {
        setInfosReport({
          ...infosReport,
          brokerSelected: null,
          id_broker: null,
          infosSelectVend: null,
          id_vend: null
        });
        setInfosSelectVend([]);
      }
      return;
    }
    if (vend) {
      if (event) {
        setInfosReport({ ...infosReport, infosSelectVend: event.label, id_vend: event.id });
      } else {
        setInfosReport({ ...infosReport, infosSelectVend: null, id_vend: null });
      }
      return;
    }

    setInfosReport({ ...infosReport, [event.target.name]: event.target.value });
  }

  function HandleExport(formatFile) {
    setAnchorEl(null);

    if (
      !infosReport.datainicial ||
      !infosReport.datafim ||
      !infosReport.tiporelatorio ||
      !infosReport.statusvenda ||
      !infosReport.tipocontratacao ||
      !infosReport.filterDateReport
    ) {
      NotificationManager.warning('Por favor, preencha todos os campos obrigatórios!', 'Atenção');
      return;
    }

    if (checkedControlYears && !infosReport.idadeinicial && !infosReport.idadefinal) {
      NotificationManager.warning(
        'Por favor, preencha os campos de idade (inicial e final)!',
        'Atenção'
      );
      return;
    }

    if (checkedControlYears && infosReport.idadeinicial > infosReport.idadefinal) {
      NotificationManager.warning(
        'A idade inicial não pode ser maior que a idade final. Verifique e tente novamente!',
        'Atenção'
      );
      return;
    }

    const infosExport = {
      infosReport: infosReport,
      tipoReport: formatFile,
      id_type_user: infoState.id_type_user,
      checkedControlYears: checkedControlYears
    };

    configAxios
      .post('/reports/repSales', infosExport, { responseType: 'blob' })
      .then((response) => {
        if (response.status === 202) {
          NotificationManager.warning(
            'Não encontramos informações para os parâmetros selecionados!',
            'Atenção'
          );
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        if (formatFile === 'pdf') {
          link.setAttribute('download', 'Relatório de vendas.pdf');
        } else {
          link.setAttribute('download', 'Relatório de vendas.xlsx');
        }
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar o relatório! Por favor, tente novamente!',
          'Atenção'
        );
      });
  }

  function ClearInputs() {
    setInfosReport([]);
  }

  async function getTypesOfHiring() {
    configAxios
      .get(`/config/getTypesOfHiring`)
      .then((response) => {
        setInfosTypesOfHiring(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar os tipos de contratação no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  return (
    <RenderPage title="Relatórios">
      <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
        <Grid container>
          <BreadcrumbsNav {...props} />
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography variant="h4" gutterBottom>
              Relatório de vendas
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Utilize as opções abaixo para filtrar o relatório de vendas
            </Typography>
          </Grid>
        </Grid>
        <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
          {!isMobile && (
            <>
              <Button
                variant="outlined"
                onClick={ClearInputs}
                sx={{ ml: 1, mr: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Limpar
              </Button>
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </>
          )}
        </Stack>
      </Stack>
      <Card>
        <CustomGrid>
          <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 2 }}>
            <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
                <FormControl component="fieldset" variant="standard">
                  <FormControlLabel
                    control={
                      <Radio
                        checked={infosReport.filterDateReport === 'dtcadastro'}
                        onChange={(event) => HandleInputChange(event)}
                        value="dtcadastro"
                        name="filterDateReport"
                      />
                    }
                    label={<CustomInfosForm sx={{ mt: 1 }}>Data de cadastro *</CustomInfosForm>}
                  />
                </FormControl>
                <FormControl component="fieldset" variant="standard">
                  <FormControlLabel
                    control={
                      <Radio
                        checked={infosReport.filterDateReport === 'dtvigencia'}
                        onChange={(event) => HandleInputChange(event)}
                        value="dtvigencia"
                        name="filterDateReport"
                      />
                    }
                    label={<CustomInfosForm sx={{ mt: 1 }}>Data da vigência *</CustomInfosForm>}
                  />
                </FormControl>
                <FormControlLabel
                  value="end"
                  control={
                    <Checkbox
                      checked={checkedControlYears}
                      onChange={(event) => setCheckedControlYears(event.target.checked)}
                      slotProps={{
                        input: { 'aria-label': 'controlled' }
                      }}
                    />
                  }
                  label={
                    <CustomInfosForm sx={{ mt: 1 }}>Considerar faixas etárias</CustomInfosForm>
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="datainicial"
                  fullWidth
                  label="Data inicial"
                  variant="outlined"
                  required
                  size="small"
                  type="date"
                  value={infosReport.datainicial || ''}
                  onChange={(event) => HandleInputChange(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="datafim"
                  fullWidth
                  label="Data final"
                  variant="outlined"
                  required
                  size="small"
                  type="date"
                  value={infosReport.datafim || ''}
                  onChange={(event) => HandleInputChange(event)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <InputLabel
                  id="label"
                  sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                  Tipo de relatório *
                </InputLabel>
                <Select
                  name="tiporelatorio"
                  fullWidth
                  size="small"
                  required
                  value={infosReport.tiporelatorio || ''}
                  onChange={(event) => HandleInputChange(event)}>
                  <MenuItem value={'Simplificado'}>Simplificado</MenuItem>
                  <MenuItem value={'Analítico'}>Analítico</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} md={3}>
                <InputLabel
                  id="label"
                  sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                  Status da venda *
                </InputLabel>
                <Select
                  name="statusvenda"
                  fullWidth
                  size="small"
                  required
                  value={infosReport.statusvenda || ''}
                  onChange={(event) => HandleInputChange(event)}>
                  <MenuItem value={'Aberta'}>Aberta</MenuItem>
                  <MenuItem value={'Análise'}>Análise</MenuItem>
                  {infoState.id_type_user !== 2 && infoState.tipo !== 'Complexo' && (
                    <MenuItem value={'Rejeitada'}>Rejeitada</MenuItem>
                  )}
                  <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                  <MenuItem value={'Aguardando corretora'}>Aguardando corretora</MenuItem>
                  <MenuItem value={'Aguardando operadora'}>Aguardando operadora</MenuItem>
                  {infoState.tipo === 'Complexo' && (
                    <MenuItem value={'Aguardando administradora'}>
                      Aguardando administradora
                    </MenuItem>
                  )}
                  <MenuItem value={'Realizar entrevista'}>Realizar entrevista</MenuItem>
                  <MenuItem value={'Analisar entrevista'}>Analisar entrevista</MenuItem>
                  {infoState.incluiagravo === 'Sim' && (
                    <MenuItem value={'Aguardando CPT(s)'}>Aguardando CPT(s)</MenuItem>
                  )}
                  <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                  {infoState.id_type_user !== 2 && <MenuItem value={'Negada'}>Negada</MenuItem>}
                  {infoState.id_type_user !== 2 && (
                    <MenuItem value={'Cancelada pelo proponente'}>Cancelada (Proponente)</MenuItem>
                  )}
                  <MenuItem value={'Todos'}>Todos</MenuItem>
                </Select>
              </Grid>
            </Grid>
            {infoState.id_type_user === 2 && infoState.id_profile === 3 && (
              <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                <Grid item xs={12} md={4}>
                  <InputLabel
                    id="label"
                    sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                    Tipo de contratação *
                  </InputLabel>
                  <Select
                    name="tipocontratacao"
                    fullWidth
                    size="small"
                    required
                    value={infosReport.tipocontratacao || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                    <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                    <MenuItem value={'3-COLETIVO POR ADESÃO'}>3-COLETIVO POR ADESÃO</MenuItem>
                    <MenuItem value={'4-TODOS'}>4-TODOS</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            )}
            {infoState.id_type_user !== 2 && (
              <>
                <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                  <Grid item xs={12} md={4}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                      Tipo de contratação *
                    </InputLabel>
                    <Select
                      name="tipocontratacao"
                      fullWidth
                      size="small"
                      required
                      value={infosReport.tipocontratacao || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      {infosTypesOfHiring.map((item) => (
                        <MenuItem key={item.id} value={item.tpcontrat}>
                          {item.tpcontrat}
                        </MenuItem>
                      ))}
                      {infosTypesOfHiring.length > 1 && (
                        <MenuItem value={'4-TODOS'}>4-TODOS</MenuItem>
                      )}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      options={infosBrokers}
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleInputChange(value, true)}
                      value={infosReport.brokerSelected || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione a corretora"
                          name="brokerSelected"
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      options={infosSelectVend}
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleInputChange(value, false, true)}
                      value={infosReport.infosSelectVend || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione o vendedor"
                          name="infosSelectVend"
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                {checkedControlYears && (
                  <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                    <Grid item xs={12} md={2}>
                      <TextField
                        name="idadeinicial"
                        fullWidth
                        label="Idade inicial"
                        variant="outlined"
                        required
                        size="small"
                        type="number"
                        value={infosReport.idadeinicial || ''}
                        onChange={(event) => HandleInputChange(event)}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        name="idadefinal"
                        fullWidth
                        label="Idade final"
                        variant="outlined"
                        required
                        size="small"
                        type="number"
                        value={infosReport.idadefinal || ''}
                        onChange={(event) => HandleInputChange(event)}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{ min: 0 }}
                      />
                    </Grid>
                  </Grid>
                )}
              </>
            )}
            {infoState.id_type_user === 2 &&
              (infoState.id_profile === 1 || infoState.id_profile === 2) && (
                <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
                  <Grid item xs={12} md={4}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                      Tipo de contratação *
                    </InputLabel>
                    <Select
                      name="tipocontratacao"
                      fullWidth
                      size="small"
                      required
                      value={infosReport.tipocontratacao || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                      <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                      <MenuItem value={'3-COLETIVO POR ADESAO'}>3-COLETIVO POR ADESÃO</MenuItem>
                      <MenuItem value={'4-TODOS'}>4-TODOS</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      options={infosSelectVend}
                      renderOption={(props, option) => <li {...props}>{option.label}</li>}
                      isOptionEqualToValue={(option, value) =>
                        value ? option.label === value : option.label === ''
                      }
                      onChange={(event, value) => HandleInputChange(value, false, true)}
                      value={infosReport.infosSelectVend || ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione o vendedor"
                          name="infosSelectVend"
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              )}
          </Box>
          <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
            <div>
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                color="success"
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                startIcon={<Iconify icon="eva:file-text-outline" />}
                endIcon={<KeyboardArrowDownIcon />}
                onClick={handleClick}>
                Exportar
              </Button>
              <Menu
                id="fade-menu"
                MenuListProps={{
                  'aria-labelledby': 'fade-button'
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}>
                <MenuItem onClick={() => HandleExport('pdf')}>
                  <PictureAsPdfIcon sx={{ mr: 1 }} />
                  <CustomInfosForm sx={{ fontSize: '13px', mt: 1 }}>
                    Exportar em pdf
                  </CustomInfosForm>
                </MenuItem>
                <MenuItem onClick={() => HandleExport('xlsx')}>
                  <DocumentScannerIcon sx={{ mr: 1 }} />
                  <CustomInfosForm sx={{ fontSize: '13px', mt: 1 }}>
                    Exportar em xlsx
                  </CustomInfosForm>
                </MenuItem>
              </Menu>
            </div>
            <Button
              variant="contained"
              color="error"
              component={RouterLink}
              to="/app/dashboard"
              startIcon={<Iconify icon="eva:close-circle-fill" />}>
              Cancelar
            </Button>
          </Stack>
        </CustomGrid>
      </Card>
    </RenderPage>
  );
};

export default RepSales;
